module.exports = __webpack_public_path__ + "static/media/happy_christmas.de3309c7.svg";